module.exports = __webpack_public_path__ + "img/img_innovation3.f3e96f7a.png";